import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { connect } from 'react-redux';
import moment from 'moment';
import Styles from './notificationSection.style';
import Notification from './notification';
import { CircularProgress } from '../../components/uielements/progress';


class NotificationSection extends Component {
  state = {
    visible: false,
    anchorEl: null,
  };
  hide = () => {
    this.setState({ visible: false });
  };
  handleVisibleChange = () => {
    this.setState({
      visible: !this.state.visible,
      anchorEl: findDOMNode(this.button),
    });
  };
  render() {
    const { title, items, notificationCount, loadMore, loading, errorMessage, loadingAll, sectionHeight, closeDrawer } = this.props;
    return (
      <div style={{ height: sectionHeight || '100%', marginBottom: 10 }}>
        <Styles.Heading variant="h5">{title}</Styles.Heading>
        {loadingAll 
          ? <Styles.ProgressWrapper><CircularProgress /></Styles.ProgressWrapper>
          : <div>
              {items && items.length > 0
                ? items.map(item => {            
                  return (
                    <Notification data={item} closeDrawer={closeDrawer} />
                  )
                })
                : <div className="dropdownListItem" style={{ cursor: 'default' }}>
                    <h5>{errorMessage}</h5>
                  </div>          
              }
              {notificationCount !== items.length &&
                (loading
                  ? <Styles.ProgressWrapper><CircularProgress /></Styles.ProgressWrapper>
                  : <Styles.LoadMoreButton
                      color="primary"
                      onClick={() => loadMore(items.length, items[0].id)}
                    >
                      Load more
                    </Styles.LoadMoreButton>
                )          
              }
            </div>
        }
      </div>
    );
  }
}

export default connect(state => ({
  ...state.App,
  customizedTheme: state.ThemeSwitcher.topbarTheme,
  height: state.App.height,
}))(NotificationSection);



// WEBPACK FOOTER //
// ./src/containers/Topbar/notificationSection.js